import { Button, List } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMaterialTab } from "~/redux/materiaal/materiaal.actions.js";

import { CloseOutlined } from "@ant-design/icons";
import { AddButton } from "~/components/buttons/AddButton.jsx";
import { $t } from "~/i18n.js";
import { DocumentTitle } from "./documentList.jsx";
import { DocumentSelectModal } from "./documentSelectModal.jsx";
import { MatDocumentModal } from "./sections/matDocumentModal.jsx";

export const DocumentUsedList = ({ documents, setDocuments }) => {
  const [openDocument, setOpenDocument] = useState(null);

  const [openCascader, setOpenCascader] = useState(false);

  const dispatch = useDispatch();
  const { currentMaterial } = useSelector((state) => state.materiaal);
  const chapters = currentMaterial?.documents?.chapters || [];
  const [newDocument, setNewDocument] = useState(null);
  const [savedDocumentId, setSavedDocumentId] = useState(null);

  const openNewDocument = async () => {
    if (currentMaterial.documents === null) {
      await dispatch(
        getMaterialTab({ activeTab: "documents", materialID: currentMaterial.id })
      );
    }
    setNewDocument({ chapter_id: chapters[0]?.id, order: 0, name: "", files: [] });
  };

  // link the saved document once the refreshed chapters contain it
  useEffect(() => {
    if (!savedDocumentId) return;
    const saved = chapters
      .flatMap((c) => c.documents || [])
      .find((d) => d.id === savedDocumentId);
    if (saved) {
      setDocuments((documents || []).concat(saved));
      setSavedDocumentId(null);
    }
  }, [savedDocumentId, currentMaterial?.documents]);

  const removeDocument = (document) => {
    setDocuments(documents.filter((doc) => doc.id !== document.id));
  };

  const addDocument = (document) => {
    setDocuments((documents || []).concat(document));
  };

  return (
    <>
      {openDocument && (
        <MatDocumentModal
          document={openDocument}
          closeModal={() => setOpenDocument(null)}
          readOnly={true}
        />
      )}

      {newDocument && (
        <MatDocumentModal
          document={newDocument}
          closeModal={() => setNewDocument(null)}
          readOnly={false}
          allChapters={chapters}
          materialID={currentMaterial.id}
          onSaved={setSavedDocumentId}
        />
      )}

      {openCascader && (
        <DocumentSelectModal
          visible={openCascader}
          addDocument={addDocument}
          title={$t("Selecteer document")}
          onClose={() => setOpenCascader(false)}
          documents={documents}
        />
      )}

      <List
        header={
          <div className="row" style={{ justifyContent: "space-between" }}>
            <p className="bold label">{$t("Verbonden documenten")}</p>
            <div className="row" style={{ gap: 6 }}>
              <Button size="small" onClick={openNewDocument}>
                {$t("Nieuw document")}
              </Button>
              <AddButton onClick={() => setOpenCascader(true)} />
            </div>
          </div>
        }
        style={{ maxWidth: 400 }}
        className="documentList"
        itemLayout="horizontal"
        dataSource={documents}
        size="small"
        locale={{ emptyText: $t("geen bestanden") }}
        renderItem={(document) => (
          <List.Item>
            <div
              className="row"
              style={{
                justifyContent: "space-between",
                minWidth: 200,
                width: "100%",
              }}
            >
              <div onClick={() => setOpenDocument(document)}>
                <DocumentTitle document={document} />
              </div>

              <Button
                danger
                icon={<CloseOutlined />}
                size="small"
                shape="circle"
                onClick={() => removeDocument(document)}
              />
            </div>
          </List.Item>
        )}
      />
    </>
  );
};
